import React from 'react'
import {
	Dropdown,
	DropdownButton,
	DropdownMenu,
	DropdownMenuItem,
	Outline,
	ProductPickerContainer,
	ProductPickerIcon,
	ProductPickerTitle,
	ProductPickerWrapper
} from './ProductPicker.style'
import { Product } from 'services/ContentfulService/models/product'
import { ChevronDownIcon } from 'experiences/learn/common/icons'
import Link from 'next/link'
import { Breadcrumbs } from 'components/elements/Breadcrumbs'
import ContentfulImage from 'experiences/shared/ContentfulImage'
import { InlineSvg } from 'components/patterns/icons/svg-tools/InlineSvg'

interface Props {
	selectedProduct: Product
	products: Product[]
}

export const LearnProductHero = ({ selectedProduct, products }: Props) => {
	const [isDropdownOpen, setDropdownOpen] = React.useState(false)

	return (
		<ProductPickerWrapper>
			<ProductPickerContainer>
				<Breadcrumbs breadcrumbs={[{ name: 'Learn', url: '/learn' }]} />
			</ProductPickerContainer>
			<ProductPickerContainer>
				<div style={{ display: 'flex' }}>
					<ProductPickerIcon>
						<ContentfulImage asset={selectedProduct.graphic} />
					</ProductPickerIcon>
					<ProductPickerTitle>
						<h1>
							Learn <span>Everything</span> About
						</h1>
						<Dropdown isOpen={isDropdownOpen}>
							<DropdownButton onClick={(): void => setDropdownOpen(!isDropdownOpen)}>
								<h1>{selectedProduct.name}</h1>
								<Outline>
									<ChevronDownIcon />
								</Outline>
							</DropdownButton>
							<DropdownMenu>
								{products.map(product => (
									<Link href={product.relativeLearnPath} key={product.id} passHref legacyBehavior>
										<DropdownMenuItem
											isActive={product.id === selectedProduct.id}
											onClick={(): void => setDropdownOpen(false)}
										>
											<InlineSvg width={26} asset={product.icon} />
											<p>{product.name}</p>
										</DropdownMenuItem>
									</Link>
								))}
							</DropdownMenu>
						</Dropdown>
					</ProductPickerTitle>
				</div>
			</ProductPickerContainer>
		</ProductPickerWrapper>
	)
}
